import React, { useState } from "react";
import DateInputField from "../common-managment/DateInputField";
import { CalendarIcon } from "../../Icons";
import HorizontalScroll from "../common/HorizontalScroll";

export default function ConstructionStatus() {
  const [selected, setSelected] = useState("EMRS");
  const [activeProcessTab, setActiveProcessTab] = useState("완료 공정");

  const options = [
    { label: "IPS", value: "IPS" },
    { label: "EMRS", value: "EMRS" },
  ];

  const status = [
    {
      name: "완료",
      color: "bg-[#8EC8FF]",
    },
    {
      name: "진행",
      color: "bg-[#78ED46]",
    },
    {
      name: "지연",
      color: "bg-[#F6C658]",
    },
    {
      name: "미진행",
      color: "bg-[#E91515]",
    },
  ];
  return (
    <div className="pb-2.5">
      <div className="flex items-stretch justify-between flex-wrap-reverse gap-0 gap-x-10 px-2 border-b border-[#C9C9C9]/30">
        {/* left side  */}
        <div className="flex items-center flex-wrap gap-5 gap-y-3 py-2">
          {/* seletion area  */}
          <div className="flex items-center flex-wrap gap-[30px] gap-y-4  px-2.5">
            {/* Process type: */}
            <div className="flex items-center gap-2.5">
              <h6 className="text-[#212121] text-[12px] font-normal whitespace-nowrap">
                공정타입 :
              </h6>
              <div className="flex items-center gap-2.5">
                {options.map((option) => (
                  <label
                    key={option.value}
                    className="flex items-center gap-1.5 cursor-pointer select-none"
                  >
                    <input
                      type="radio"
                      name="processType"
                      value={option.value}
                      checked={selected === option.value}
                      onChange={() => setSelected(option.value)}
                      className="hidden"
                    />
                    <span
                      className={`w-4 h-4 rounded-full border border-gray-500 flex items-center justify-center transition-all duration-200 ${
                        selected === option.value ? "border-gray-700" : ""
                      }`}
                    >
                      {selected === option.value && (
                        <span className="w-2 h-2 bg-gray-800 rounded-full"></span>
                      )}
                    </span>
                    <span className="text-[12px] text-[#242424]">
                      {option.label}
                    </span>
                  </label>
                ))}
              </div>
            </div>
            {/* date  */}
            <div className="flex items-center gap-2.5">
              <h6 className="text-[#212121] text-[12px] font-normal whitespace-nowrap">
                시작 일자 :
              </h6>
              <DateInputField
                value={"2025-08-29"}
                className="border-[#C9C9C9]/70 bg-white text-sm"
              />
              <CalendarIcon />
            </div>
          </div>

          <button className="text-[#242424] px-2.5 py-1.5 text-[12px] bg-white rounded-[4px] border border-[#C9C9C9]/50">
            현황 보기
          </button>
        </div>

        {/* right side  */}
        <div className="px-2.5 lg:border-l border-[#C9C9C9]/30 flex items-center gap-5 py-2">
          {status.map((it, idx) => (
            <div key={idx} className="flex items-center gap-2.5">
              <div
                className={`w-[17px] aspect-square rounded-full ${it.color}`}
              ></div>

              <span className="text-[#242424] text-[12px]">{it.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="w-fit max-w-full flex flex-col items-center px-2.5 ">
        <p className="py-[15px] text-center text-[#242424] text-[12px]">
          [ EMRS로 검색된 총 건수 : <span className="text-[#08F]">2206건</span>{" "}
          ]
        </p>

        <HorizontalScroll className="w-full">
          <div className="flex items-center gap-1 whitespace-nowrap">
            {[
              "완료 공정",
              "진행 공정",
              "종료 지연",
              "착수 지연",
              "Captive 관련 기기현황",
            ].map((it, idx) => (
              <button
                key={idx}
                className={`px-9 p-[3px] rounded-t-[4px] text-[12px] transition-all ease-linear duration-300 ${
                  activeProcessTab === it
                    ? "bg-white text-[#242424]"
                    : "bg-[#E6E6E6] text-[#797979]"
                }`}
                onClick={() => setActiveProcessTab(it)}
              >
                {it}
              </button>
            ))}
          </div>
        </HorizontalScroll>
      </div>

      <div className="px-2.5 py-0.5">
        <HorizontalScroll
          overflow="overflow-auto"
          className="w-full max-h-[250px]"
          isShowScrollBar={true}
        >
          <table className=" w-full text-[12px] text-[#242424] text-center border border-[#C9C9C9]/30 border-t-0 whitespace-nowrap relative">
            <thead className="sticky top-0 z-[1]">
              <tr className="font-normal divide-x divide-[#C9C9C9]/30 bg-[#DBDBDB] ">
                <th className="py-1 px-2.5">IPS 번호</th>
                <th className="py-1 px-2.5">IPS 세부 정보</th>
                <th className="py-1 px-2.5">EMRS 번호</th>
                <th className="py-1 px-2.5">IPS 세부 정보</th>
                <th className="py-1 px-2.5">기준 시작</th>
                <th className="py-1 px-2.5">기준 종료</th>
                <th className="py-1 px-2.5">기간(일)</th>
                <th className="py-1 px-2.5">기준 종료</th>
                <th className="py-1 px-2.5">기준 종료</th>
              </tr>
            </thead>
            <tbody>
              {["", "", "", "", "", "", "", "", ""].map((_, idx) => (
                <tr
                  key={idx}
                  className="bg-[#F1F1F1] font-light border-t border-[#C9C9C9]/30 divide-x divide-[#C9C9C9]/30 hover:bg-[#D2DDFF] transition-all ease-linear duration-100"
                >
                  <td className="py-1.5 px-2.5">50215478521</td>
                  <td className="py-1 px-2.5">
                    <p className="max-w-[350px] text-ellipsis line-clamp-1 overflow-hidden whitespace-nowrap">
                      CW DISCHANGE CONDUIT AREA @ MUDMAT CONCRETE
                    </p>
                  </td>
                  <td className="py-1 px-2.5">25852155DDFDF255</td>
                  <td className="py-1 px-2.5">
                    <p className="max-w-[350px] text-ellipsis line-clamp-1 overflow-hidden whitespace-nowrap">
                      CW DISCHANGE CONDUIT AREA @ MUDMAT CONCRETE
                    </p>
                  </td>
                  <td className="py-1 px-2.5">2025-12-01</td>
                  <td className="py-1 px-2.5">2025-12-01</td>
                  <td className="py-1 px-2.5">5</td>
                  <td className="py-1 px-2.5">2025-12-01</td>
                  <td className="py-1 px-2.5">2025-12-01</td>
                </tr>
              ))}
            </tbody>
          </table>
        </HorizontalScroll>
      </div>
    </div>
  );
}
